import {
  socketMessage,
  webRtcMessageId,
  mediaType,
  mediaStatus
} from "WEBSOCKET/constants";
import {
  CANVAS_TYPES,
  CANVAS_SOURCE,
  USER_ROLES,
  SESSION_STATUS,
  ACTIONS,
  USER_ADMISSION_STATUS,
  PARTICIPANT_STATUS,
  CO_BROWSE_SESSION_STATUS
} from "UTILS/Constants";
import * as log from "loglevel";
import { makeUserMediaTypeUniform, postMesageToCoBrowseIframeUtility } from "UTILS/Utility";
import { sendWebsocketMessage } from "WEBSOCKET/WebsocketHandler";
import { customerCoBrowseAction } from "CONFIG/ActionFactory";

log.setLevel("info");

export const handleMessage = (data, store) => {
  const reducerData = store.getState();
  const userRole = reducerData.UserReducer.userDetails.role;
  const sessionStatus = reducerData.SessionReducer.sessionDetails.sessionStatus;
  const sessionKey = reducerData.SessionReducer.sessionDetails.sessionKey;
  const presenter = reducerData.RoomMetaDataReducer.roomMetaData.presenterId;
  const uniqueId = reducerData.SessionReducer.uniqueId;
  const showCustomerCoBrowse = reducerData.CustomerCoBrowseReducer.showCustomerCoBrowse;
  const coBrowseBaseUrl = reducerData.CustomerCoBrowseReducer.coBrowseBaseUrl;
  const token = reducerData.SessionReducer.sessionDetails.token
  switch (data.action) {
    case socketMessage.subCategories.SESSION._JOIN_SESSION_REQUEST:
      // only received by Agent from server when user wants to join the session
      store.dispatch({
        type: ACTIONS.UPDATE_PARTICIPANTS,
        participant: { 
          userName: data.userName,
          status: data.status,
          admissionStatus: data.admissionStatus,
          uniqueId: data.uniqueId
        }
      });

      const isReductionLogs = (
        (reducerData.SessionReducer.sessionDetails && reducerData.SessionReducer.sessionDetails.isReductionLogs) ||
        (reducerData.OrganisationReducer.customerData && reducerData.OrganisationReducer.customerData.isReductionLogs)
      );
      const isReductionLogsEnable =  isReductionLogs ? (isReductionLogs.isEnable ? true : false) : false;
      if ( isReductionLogsEnable ) {
        const organiser = reducerData.RoomMetaDataReducer.roomMetaData.organiser;
        const uniqueId = reducerData.SessionReducer.uniqueId;
        if ( organiser === uniqueId ) {
          store.dispatch({
            type: ACTIONS.PARTICIPANT_ADMITTED_OR_REJECTED,
            participant: {
              uniqueId: data.uniqueId,
              isAdmitted: true,
            },
          });
          sendWebsocketMessage(socketMessage.events.MESSAGE, {
            data: {
              category: socketMessage.category.SESSION,
              action: socketMessage.subCategories.SESSION.JOIN_SESSION_REPLY,
              isAdmitted: true,
              uniqueId: data.uniqueId,
              sessionKey: sessionKey,
            }
          })(store.dispatch, store.getState);
        }
      }
      break;
    case socketMessage.subCategories.SESSION._JOIN_SESSION_REPLY:
      // only received by User from server after Agent admits the user
      // dispatched to update participant array
      store.dispatch({
        type: ACTIONS.PARTICIPANT_ADMITTED_OR_REJECTED,
        participant: { 
          uniqueId: data.uniqueId,
          isAdmitted: data.isAdmitted,
          userName: data.userName
        }
      });
      // dispatched to update user's self admissionStatus
      store.dispatch({
        type: ACTIONS.USER_ADMITTED,
        userAdmissionStatus: data.isAdmitted,
        userName: data.userName
      });
      break;
    
    case socketMessage.subCategories.SESSION._JOIN:
      // set participant Id
      data.color !== null && data.color != undefined &&
        store.dispatch({
          type: ACTIONS.WHITEBOARD.SET_CANVAS_COLOR,
          color: data.color
        })

      store.dispatch({
        type: ACTIONS.UPDATE_CURRENT_PARTICIPANT_INFO,
        currentParticipantInfo: {
          participantId: data.participantId,
          uniqueId: data.uniqueId,
          isOrganizer: data.uniqueId === data.organiser
        }
      });
      //  set session status
      store.dispatch({
        type: ACTIONS.SET_SESSION_STATUS,
        sessionStatus: data.sessionStatus
      });
      if (data.sessionStatus === SESSION_STATUS.ACTIVE || data.sessionStatus === SESSION_STATUS.CLOSING) {
        sendWebsocketMessage(socketMessage.events.MESSAGE, {
          data: {
            category: socketMessage.category.SESSION,
            action: socketMessage.subCategories.SESSION.GET_ALL_SESSION_DATA,
            sessionKey: sessionKey
          }
        })(store.dispatch, store.getState);
      }
      //(userRole === USER_ROLES.AGENT || userRole === USER_ROLES.ADMIN)
      break;
    case socketMessage.subCategories.SESSION._STARTED:
      store.dispatch({
        type: ACTIONS.SET_SESSION_STATUS,
        sessionStatus: SESSION_STATUS.ACTIVE
      });
      sendWebsocketMessage(socketMessage.events.MESSAGE, {
        data: {
          category: socketMessage.category.SESSION,
          action: socketMessage.subCategories.SESSION.GET_ALL_SESSION_DATA,
          sessionKey: sessionKey
        }
      })(store.dispatch, store.getState);
      break;
    case socketMessage.subCategories.SESSION._GET_ALL_SESSION_DATA:
      // empty snapshot reducer 
      store.dispatch({
        type: ACTIONS.SNAPSHOT.DELETE_CANVAS,
      });

      store.dispatch({
        type: ACTIONS.WHITEBOARD.SET_CANVAS_DATA,
        data: data.canvas
      });
      var participants = makeUserMediaTypeUniform(data.participants);
      store.dispatch({
        type: ACTIONS.SET_PARTICIPANTS,
        participants: participants
      });
      let roomMetaData = _.cloneDeep(data.roomMetaData);
      let currentAnnotation = data.roomMetaData.currentAnnotation
      let activeAnnotationDetails = {};
      if (currentAnnotation) {
        activeAnnotationDetails.annotation = currentAnnotation
        activeAnnotationDetails.isSelected = true;
      } else {
        activeAnnotationDetails.annotation = ""
        activeAnnotationDetails.isSelected = false;
      }
      roomMetaData.activeAnnotationDetails = activeAnnotationDetails;
      store.dispatch({
        type: ACTIONS.SET_ROOM_META_DATA,
        roomMetaData: roomMetaData
      });
      store.dispatch({
        type: ACTIONS.CHAT.SET_MESSAGES,
        messages: data.chat
      });
      store.dispatch({
        type: ACTIONS.LOCATION.GET_ALL_LOCATION_DATA,
        eta: data.location.eta,
        participants: data.location.participants
      });
      store.dispatch({
        type: ACTIONS.SET_IS_RECORDING,
        value: data.roomMetaData.isRecordingEnable,
      });
      store.dispatch({
        type: ACTIONS.SET_IS_SCREEN_MASKING,
        value: data.roomMetaData.isScreenMaskingEnable,
      });
      //For late arrivals show popup same as _WEBRTC_PERMISSION_REQUEST
      if (
        data.roomMetaData.mediaType == mediaType.AUDIO ||
        data.roomMetaData.mediaType == mediaType.AUDIO_VIDEO
      ) {
        store.dispatch({
          type: ACTIONS.SET_WEBRTC_REPLY_PERMISSION,
          webRtcPermissionReply: null
        });
        store.dispatch({
          type: ACTIONS.SET_WEBRTC_REQUEST_PERMISSION,
          webRtcPermissionRequest: data.roomMetaData.mediaType
        });
      }

      store.dispatch({
        type: ACTIONS.APP_EMULATION.APP_EMULATION_REQUEST,
        value: data.roomMetaData.isAppEmulationRunning
      });

      if(presenter !== uniqueId 
         && (roomMetaData.cobrowseState === CO_BROWSE_SESSION_STATUS.CO_BROWSE_STARTED 
         || roomMetaData.cobrowseState === CO_BROWSE_SESSION_STATUS.CO_BROWSE_RUNNING)) {
        //check if cobrowse session is started set permission request true to join session
        store.dispatch({
          type: ACTIONS.CO_BROWSE.CO_BROWSE_REQUEST,
          value: true
        });
        
        if(roomMetaData.cobrowseState === CO_BROWSE_SESSION_STATUS.CO_BROWSE_RUNNING) {
          //if session is in running state set request flag to ask permission and 
          //status to started for call join api after accept permission
          // CO_BROWSE_SESSION_STATUS will be set to CO_BROWSE_RUNNING when cobrowse iframe gets loaded
          store.dispatch({
            type: ACTIONS.CO_BROWSE.SET_CO_BROWSE_SESSION_STATUS,
            value: CO_BROWSE_SESSION_STATUS.CO_BROWSE_STARTED
          });
        }
      }
 
      /*
      * if any user in the participant list is on waiting screen before start session or  
      * on refresh at agent side make user latest updated participant
      */ 
      if(userRole === USER_ROLES.AGENT && data.participants.length > 1) {
        let participant = data.participants.filter((user)=>user.role === USER_ROLES.USER && 
        user.admissionStatus == USER_ADMISSION_STATUS.PENDING)
        if(participant.length > 0) {
          store.dispatch({
            type: ACTIONS.UPDATE_PARTICIPANTS,
            participant: participant[0]
          });
          const isReductionLogs = (
            (reducerData.SessionReducer.sessionDetails && reducerData.SessionReducer.sessionDetails.isReductionLogs) ||
            (reducerData.OrganisationReducer.customerData && reducerData.OrganisationReducer.customerData.isReductionLogs)
          );
          const isReductionLogsEnable =  isReductionLogs ? (isReductionLogs.isEnable ? true : false) : false;
          if (isReductionLogsEnable) {
            participant.map((participantData) => {
              if (participantData.status === PARTICIPANT_STATUS.WAITING) {
                store.dispatch({
                  type: ACTIONS.PARTICIPANT_ADMITTED_OR_REJECTED,
                  participant: {
                    uniqueId: participantData.uniqueId,
                    isAdmitted: true,
                  },
                });
                sendWebsocketMessage(socketMessage.events.MESSAGE, {
                  data: {
                    category: socketMessage.category.SESSION,
                    action: socketMessage.subCategories.SESSION.JOIN_SESSION_REPLY,
                    isAdmitted: true,
                    uniqueId: participantData.uniqueId,
                    sessionKey: sessionKey,
                  }
                })(store.dispatch, store.getState);
              }
            });
          }
        }
      }

      if(data.roomMetaData.snapshot.snapshoteeId) {
        store.dispatch({
          type: ACTIONS.SNAPSHOT.SET_SNAPSHOT_STATUS,
          value: true
        });
      }
      // send add canvas message if there is no canvas
      if (!data.canvas.totalCanvas && roomMetaData.organiser === uniqueId) {
        //send 'add regular canvas' msg if agent
        sendWebsocketMessage(socketMessage.events.MESSAGE, {
          data: {
            category: socketMessage.category.WHITEBOARD,
            action: socketMessage.subCategories.WHITEBOARD.ADD_CANVAS,
            sessionKey: sessionKey,
            // token: reducerData.UserReducer.userDetails.token,
            canvasType: CANVAS_TYPES.REGULAR,
            canvasSource: CANVAS_SOURCE.REGULAR
          }
        })(store.dispatch, store.getState);
      }
      if (roomMetaData.organiser === uniqueId) {
        store.dispatch({
          type: ACTIONS.SET_PREVIEW_MODAL,
          value: true
        });
      }
      break;
      
    case socketMessage.subCategories.SESSION._END_SESSION:
      // When the owner ends the eXcloser meeting, the follower's reconnection information is also deleted.
      sessionStorage.removeItem('reconnectionUrlForFollower');
      // Post End_session_without_confirmation from Presenter's end once agent end loookit session
      if (showCustomerCoBrowse && presenter == uniqueId) {
        postMesageToCoBrowseIframeUtility(token, coBrowseBaseUrl)
        setTimeout(() => {
          customerCoBrowseAction.endCustomerCoBrowse();
        }, 500);
      }
      store.dispatch({
        type: ACTIONS.SET_END_SESSION_FLAG,
        flag: true
      });
      break;
    case socketMessage.subCategories.SESSION._SESSION_DELETED:
      store.dispatch({
        type: ACTIONS.SET_SESSION_STATUS,
        sessionStatus: SESSION_STATUS.DELETED
      });
      break;
    case socketMessage.subCategories.SESSION._SESSION_UPDATED:
      store.dispatch({
        type: ACTIONS.SET_SESSION_STATUS,
        sessionStatus: SESSION_STATUS.UPDATED
      });
      break;
    case socketMessage.subCategories.SESSION._ALLOW_EDIT_ACCESS:
      store.dispatch({
        type: ACTIONS.SET_ALLOW_EDIT,
        participant: {
          participantId: data.participantId,
          allowEditAccess: data.allowEditAccess
        }
      });
      break;
    case socketMessage.subCategories.SESSION._CANCEL_SESSION:
      store.dispatch({
        type: ACTIONS.SET_SESSION_STATUS,
        sessionStatus: SESSION_STATUS.ABANDONED
      });
      break;
    case socketMessage.subCategories.SESSION._INCOMING_CALL:
      store.dispatch({
        type: ACTIONS.SET_IS_CALLING,
        value: true
      });
      break;
    case socketMessage.subCategories.SESSION._DISCONNECT_CALL:
      store.dispatch({
        type: ACTIONS.SET_IS_CALLING,
        value: false
      });
      break;
    default:
      break;
  }
};
